"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProducerEventVoiceLanguage = void 0;
var ProducerEventVoiceLanguage;
(function (ProducerEventVoiceLanguage) {
    ProducerEventVoiceLanguage["enUS"] = "en-US";
    ProducerEventVoiceLanguage["enGB"] = "en-GB";
    ProducerEventVoiceLanguage["enIE"] = "en-IE";
    ProducerEventVoiceLanguage["esEs"] = "es-ES";
    ProducerEventVoiceLanguage["gaIE"] = "ga-IE";
    ProducerEventVoiceLanguage["frCA"] = "fr-CA";
    ProducerEventVoiceLanguage["svSE"] = "sv-SE";
    ProducerEventVoiceLanguage["afZA"] = "af-ZA";
    ProducerEventVoiceLanguage["amET"] = "am-ET";
    ProducerEventVoiceLanguage["arEG"] = "ar-EG";
    ProducerEventVoiceLanguage["arSA"] = "ar-SA";
    ProducerEventVoiceLanguage["azAZ"] = "az-AZ";
    ProducerEventVoiceLanguage["bgBG"] = "bg-BG";
    ProducerEventVoiceLanguage["bnBD"] = "bn-BD";
    ProducerEventVoiceLanguage["bnIN"] = "bn-IN";
    ProducerEventVoiceLanguage["bsBA"] = "bs-BA";
    ProducerEventVoiceLanguage["caES"] = "ca-ES";
    ProducerEventVoiceLanguage["csCZ"] = "cs-CZ";
    ProducerEventVoiceLanguage["cyGB"] = "cy-GB";
    ProducerEventVoiceLanguage["daDK"] = "da-DK";
    ProducerEventVoiceLanguage["deAT"] = "de-AT";
    ProducerEventVoiceLanguage["deCH"] = "de-CH";
    ProducerEventVoiceLanguage["deDE"] = "de-DE";
    ProducerEventVoiceLanguage["elGR"] = "el-GR";
    ProducerEventVoiceLanguage["enAU"] = "en-AU";
    ProducerEventVoiceLanguage["enCA"] = "en-CA";
    ProducerEventVoiceLanguage["enHK"] = "en-HK";
    ProducerEventVoiceLanguage["enIN"] = "en-IN";
    ProducerEventVoiceLanguage["esMX"] = "es-MX";
    ProducerEventVoiceLanguage["esUS"] = "es-US";
    ProducerEventVoiceLanguage["etEE"] = "et-EE";
    ProducerEventVoiceLanguage["euES"] = "eu-ES";
    ProducerEventVoiceLanguage["faIR"] = "fa-IR";
    ProducerEventVoiceLanguage["fiFI"] = "fi-FI";
    ProducerEventVoiceLanguage["filPH"] = "fil-PH";
    ProducerEventVoiceLanguage["frBE"] = "fr-BE";
    ProducerEventVoiceLanguage["frCH"] = "fr-CH";
    ProducerEventVoiceLanguage["frFR"] = "fr-FR";
    ProducerEventVoiceLanguage["heIL"] = "he-IL";
    ProducerEventVoiceLanguage["hiIN"] = "hi-IN";
    ProducerEventVoiceLanguage["hrHR"] = "hr-HR";
    ProducerEventVoiceLanguage["huHU"] = "hu-HU";
    ProducerEventVoiceLanguage["hyAM"] = "hy-AM";
    ProducerEventVoiceLanguage["idID"] = "id-ID";
    ProducerEventVoiceLanguage["isIS"] = "is-IS";
    ProducerEventVoiceLanguage["itIT"] = "it-IT";
    ProducerEventVoiceLanguage["jaJP"] = "ja-JP";
    ProducerEventVoiceLanguage["jvID"] = "jv-ID";
    ProducerEventVoiceLanguage["kaGE"] = "ka-GE";
    ProducerEventVoiceLanguage["kkKZ"] = "kk-KZ";
    ProducerEventVoiceLanguage["kmKH"] = "km-KH";
    ProducerEventVoiceLanguage["knIN"] = "kn-IN";
    ProducerEventVoiceLanguage["koKR"] = "ko-KR";
    ProducerEventVoiceLanguage["loLA"] = "lo-LA";
    ProducerEventVoiceLanguage["ltLT"] = "lt-LT";
    ProducerEventVoiceLanguage["lvLV"] = "lv-LV";
    ProducerEventVoiceLanguage["mkMK"] = "mk-MK";
    ProducerEventVoiceLanguage["mlIN"] = "ml-IN";
    ProducerEventVoiceLanguage["mnMN"] = "mn-MN";
    ProducerEventVoiceLanguage["msMY"] = "ms-MY";
    ProducerEventVoiceLanguage["mtMT"] = "mt-MT";
    ProducerEventVoiceLanguage["myMM"] = "my-MM";
    ProducerEventVoiceLanguage["nbNO"] = "nb-NO";
    ProducerEventVoiceLanguage["neNP"] = "ne-NP";
    ProducerEventVoiceLanguage["nlBE"] = "nl-BE";
    ProducerEventVoiceLanguage["nlNL"] = "nl-NL";
    ProducerEventVoiceLanguage["plPL"] = "pl-PL";
    ProducerEventVoiceLanguage["psAF"] = "ps-AF";
    ProducerEventVoiceLanguage["ptBR"] = "pt-BR";
    ProducerEventVoiceLanguage["ptPT"] = "pt-PT";
    ProducerEventVoiceLanguage["roRO"] = "ro-RO";
    ProducerEventVoiceLanguage["ruRU"] = "ru-RU";
    ProducerEventVoiceLanguage["siLK"] = "si-LK";
    ProducerEventVoiceLanguage["skSK"] = "sk-SK";
    ProducerEventVoiceLanguage["slSI"] = "sl-SI";
    ProducerEventVoiceLanguage["soSO"] = "so-SO";
    ProducerEventVoiceLanguage["sqAL"] = "sq-AL";
    ProducerEventVoiceLanguage["srRS"] = "sr-RS";
    ProducerEventVoiceLanguage["suID"] = "su-ID";
    ProducerEventVoiceLanguage["swKE"] = "sw-KE";
    ProducerEventVoiceLanguage["taIN"] = "ta-IN";
    ProducerEventVoiceLanguage["teIN"] = "te-IN";
    ProducerEventVoiceLanguage["thTH"] = "th-TH";
    ProducerEventVoiceLanguage["trTR"] = "tr-TR";
    ProducerEventVoiceLanguage["ukUA"] = "uk-UA";
    ProducerEventVoiceLanguage["urPK"] = "ur-PK";
    ProducerEventVoiceLanguage["uzUZ"] = "uz-UZ";
    ProducerEventVoiceLanguage["viVN"] = "vi-VN";
    ProducerEventVoiceLanguage["zhCN"] = "zh-CN";
    ProducerEventVoiceLanguage["zhHK"] = "zh-HK";
    ProducerEventVoiceLanguage["zhTW"] = "zh-TW";
    ProducerEventVoiceLanguage["zuZA"] = "zu-ZA";
    ProducerEventVoiceLanguage["esES"] = "es-ES";
    ProducerEventVoiceLanguage["glES"] = "gl-ES";
})(ProducerEventVoiceLanguage = exports.ProducerEventVoiceLanguage || (exports.ProducerEventVoiceLanguage = {}));
//# sourceMappingURL=producer-event-voice-language.js.map